import React from "react";
import firebase from "./../Firebase.js";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";

export default class PersonalInfoForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: props.open,
      restaurantName: props.restaurantName,
      firstName: props.firstName,
      lastName: props.lastName,
      email: props.email,
      phoneNumber: props.phoneNumber,
    };
    this.handleClickOpen = this.handleClickOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleClickOpen() {
    this.setState({
      open: true,
    });
  }

  handleClose() {
    // Make sure all the information that is needed is filled out otherwise don't let the user close the tab.
    if (
      this.props.firstName == null ||
      this.props.lastName == null ||
      this.props.email == null
    ) {
      alert("Please fill out required info to proceed");
    } else {
      this.setState({
        open: false,
      });
    }
  }

  handleSave(e) {
    e.preventDefault();
    const database = firebase.firestore();
    const batch = database.batch();

    if (this.props.userInfo.userType === "restaurant") {
      const menuDocRef = database
        .collection("RestaurantMenu")
        .doc(this.state.restaurantName);
      batch.set(
        menuDocRef,
        { phoneNumber: this.state.phoneNumber },
        { merge: true },
      );

      batch.commit();
    }
    this.setState({
      open: false,
    });

    // The individual doesn't have the name of their organisation (as they aren't one)
    // and so this state needs to be removed from the state array before it is put
    // into the database
    if (this.props.userInfo.userType === "individual") {
      const stateTemp = { ...this.state }; // make a separate copy of the array
      delete stateTemp.restaurantName;

      // if the user changed the email then we have to update their sign in options.
      // In the event the user hasn't logged in recently nothing will be updated.
      if (this.props.email !== this.state.email) {
        this.props.currentUser
          .updateEmail(this.state.email)
          .then((props) => {
            // Update successful.
            this.props.handleInfoUpdate(stateTemp);
            console.log("Email Updated");
          })
          // eslint-disable-next-line n/handle-callback-err
          .catch(function (error) {
            // eslint-disable-next-line no-undef
            alert(
              "It's been too long since you signed in last please log out and sign in again.",
            );
          });
      } else {
        this.props.handleInfoUpdate(stateTemp);
      }
    } else {
      this.props.handleInfoUpdate(this.state);
    }
    return null;
  }

  handleChange(e) {
    const target = e.target;
    let value = target.value;
    const name = target.name;
    const letters = /^[A-Za-z]+$/;

    if (name === "firstName" || name === "lastName") {
      value = value.trim();
      if (value.match(letters) || value === "") {
        this.setState({
          [name]: value,
        });
      } else {
        alert(
          "Names can only include letters.  Please correct this to create an account",
        );
      }
    } else {
      this.setState({
        [name]: value,
      });
    }
  }

  render() {
    // Depending on whether this is an organisation or a restaurant it will show
    // the proper label.
    let labelName = "Organisation Name";
    if (this.props.userInfo.userType === "restaurant") {
      labelName = "Restaurant Name";
    }
    return (
      <div>
        <Button
          className="Edit-Button"
          variant="outlined"
          color="primary"
          onClick={this.handleClickOpen}
        >
          edit
        </Button>
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle
            id="form-dialog-title"
            style={{ padding: "16px 24px 0px" }}
          >
            Your Information
          </DialogTitle>
          <DialogContent>
            <form onSubmit={this.handleSave}>
              {this.props.userInfo.userType !== "individual" && (
                <TextField
                  margin="dense"
                  id="restaurant name"
                  label={labelName}
                  name="restaurantName"
                  value={this.state.restaurantName}
                  onChange={this.handleChange}
                  fullWidth
                  required
                />
              )}
              <TextField
                margin="dense"
                id="first name"
                label="First Name"
                name="firstName"
                value={this.state.firstName}
                onChange={this.handleChange}
                fullWidth
                required
              />
              <TextField
                margin="dense"
                id="last name"
                label="Last Name"
                name="lastName"
                value={this.state.lastName}
                onChange={this.handleChange}
                fullWidth
                required
              />
              <TextField
                margin="dense"
                id="email"
                label="Email Address"
                type="email"
                name="email"
                value={this.state.email}
                onChange={this.handleChange}
                fullWidth
                required
              />
              <TextField
                margin="dense"
                id="phone number"
                label="Phone Number"
                name="phoneNumber"
                value={this.state.phoneNumber}
                onChange={this.handleChange}
                fullWidth
                required
              />
              <DialogActions>
                <Button onClick={this.handleClose} color="primary">
                  Cancel
                </Button>
                <Button type="submit" color="primary">
                  Save
                </Button>
              </DialogActions>
            </form>
          </DialogContent>
        </Dialog>
      </div>
    );
  }
}
